'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _most = require('most');

var _curried = require('./_curried');

var tapError = (0, _curried.curry2)(function (f, stream) {
  return (0, _most.recoverWith)(function (err) {
    f(err);
    return (0, _most.throwError)(err);
  }, stream);
});

exports.default = tapError;